<template>
  <div v-if="!getLoadingBoolean">
    <h2>{{ $t('message.credit.us.pinHeader') }}</h2>
    <p>{{ $t('message.credit.us.pinSubheader') }}</p>
    <mobialis-form-with-validation @onValidate="continueForm">
      <div class="field-wrap col-12 col-sm-7 pl-0">
        <mobialis-text-input-with-validation
          class="pl-0"
          rules="required"
          :label="$t('message.credit.us.fieldLabel')"
          v-model="pin"
          vid="pin"
          :type="textOrPassword"
          data-cy="pin"
        ></mobialis-text-input-with-validation>
        <img
          v-show="!showPin"
          @click="showPin = !showPin"
          class="eyecon"
          :src="require('@/assets/eye.svg')"
          alt="eye icon"
        />
        <img
          v-show="showPin"
          @click="showPin = !showPin"
          class="eyeslashcon"
          :src="require('@/assets/eye-slash.svg')"
          alt="Arrow Down"
        />
      </div>
      <mobialis-button type="submit" class="continueButton" data-cy="continue">{{
        $t('message.common.continue')
      }}</mobialis-button>
    </mobialis-form-with-validation>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import log from '@/services/log';

export default {
  name: 'access-pin',
  data() {
    return {
      pin: '',
      showPin: false,
    };
  },
  methods: {
    ...mapActions('usCredit', ['submitAccessPin']),
    async continueForm(isValid) {
      if (!isValid) {
        return;
      }
      try {
        this.$store.commit('SET_LOADING', true);
        await this.submitAccessPin(this.pin);
        this.$router.push({
          name: `credit-results-${this.baseRoute}`,
        });
      } catch (error) {
        log('Error in submitting accessPin for US credit!', error);
        this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
      } finally {
        try {
          await this.$store.dispatch('lead/updateLead');
        } catch (err) {
          log('Error in 700Credit accessPin - Update Lead: ', err);
          this.$router.push({ name: `credit-in-error-${this.baseRoute}` });
        }
        this.$store.commit('SET_LOADING', false);
      }
    },
  },
  computed: {
    ...mapGetters(['getLoadingBoolean']),
    textOrPassword() {
      return this.showPin ? 'text' : 'password';
    },
  },
};
</script>

<style lang="scss" scoped>
@media only screen and (max-width: 350px) {
  div {
    .inputContainer {
      width: 100%;
    }
  }
}
.inputContainer {
  width: 50%;
}
.field-wrap {
  position: relative;
}
img.eyecon {
  width: 21px;
  position: absolute;
  right: 30px;
  top: 43px;
}
img.eyeslashcon {
  width: 21px;
  float: right;
  position: absolute;
  right: 30px;
  top: 43px;
}
h2 {
  font-size: 22px;
  font-weight: bold;
}
.continueButton {
  margin-top: 285px;
}
</style>
